import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ScrollToTop from "./components/sections/ScrollToTop";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { HelmetProvider } from "react-helmet-async"; // Importez HelmetProvider
import "./i18n"; // Assurez-vous que votre configuration i18n est importée

const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <GoogleOAuthProvider clientId="VOTRE_CLIENT_ID_GOOGLE.apps.googleusercontent.com">
        <BrowserRouter>
            <HelmetProvider>
                    <App />
            </HelmetProvider>
        </BrowserRouter>
    </GoogleOAuthProvider>
);


reportWebVitals();
